import React from 'react';
import { useEmailServer } from '@debbie/cortex/dist/email-servers/index.js';
import Well from './Well.js';
import { ExclusiveContentBadge } from './ExclusiveContent.js';
import { h } from '@debbie/cortex/dist/index.js';
const EmailServer = (props) => {
    const emailServerLoadable = useEmailServer(props.emailServerId);
    const emailServer = h.hasData(emailServerLoadable)
        ? emailServerLoadable.data
        : null;
    if (!emailServer) {
        return null;
    }
    return (React.createElement(Well, null,
        React.createElement("p", null,
            React.createElement("b", null, emailServer.provider),
            " ",
            React.createElement(ExclusiveContentBadge, null)),
        React.createElement("p", null,
            emailServer.fromName,
            " ",
            '<',
            emailServer.fromEmail,
            '>')));
};
export default EmailServer;
//# sourceMappingURL=EmailServer.js.map